import { AD_TYPE } from '@seek/je-shared-data';
import { upgraded } from '@src/job';
import { stepConfig } from './stepConfig';

export type GetStepsParams = {
  isUpgradeable: boolean;
  hasJobUpgraded: boolean;
  selectedAdType?: AD_TYPE;
  createdJobId?: string | null;
};

export const getSteps = (params: GetStepsParams) => {
  const { isUpgradeable, createdJobId, selectedAdType, hasJobUpgraded } =
    params;

  const {
    title,
    basicDetails,
    editTitle,
    editBasicDetails,
    createAccount,
    verifyEmail,
    createBusiness,
    enhanceJob,
    payment,
    jobSummaryAndDesc,
    postJobSuccess
  } = stepConfig(createdJobId, selectedAdType);

  const postJobSteps = [title, basicDetails];
  const editJobSteps = [editTitle, editBasicDetails];

  const showPayment =
    isUpgradeable && upgraded(selectedAdType) && !hasJobUpgraded;

  return [
    createAccount,
    verifyEmail,
    createBusiness,
    ...(createdJobId ? editJobSteps : postJobSteps),
    ...(isUpgradeable ? [enhanceJob] : []),
    ...(showPayment ? [payment] : []),
    jobSummaryAndDesc,
    postJobSuccess
  ];
};
